package music.jammers.client.shared.component.member.info.legend.presentation.ui

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.ic_info
import music.jammers.client.shared.component.member.info.legend.di.MemberInfoDIComponent
import org.jetbrains.compose.resources.painterResource

@Composable
fun MemberInfoLegendComponent(
    extended: Boolean = false,
    modifier: Modifier = Modifier,
) {
    val viewModel = remember {
        MemberInfoDIComponent().memberInfoLegendViewModel.apply { onReady(extended) }
    }

    IconButton(
        onClick = viewModel::onInfoButtonClicked,
        modifier = modifier.padding(bottom = 6.dp),
    ) {
        Icon(
            painter = painterResource(Res.drawable.ic_info),
            tint = MaterialTheme.colorScheme.secondary,
            contentDescription = "Info",
        )
    }
}